import Icon from "@ant-design/icons";

const SVG = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 4v6a6 6 0 0 0 12 0V4" />
    <path d="M4 21h16" />
  </svg>
);

const UnderlineIcon = (props) => <Icon component={SVG} {...props} />;

export default UnderlineIcon;
